import { render, staticRenderFns } from "./bv-product-list.vue?vue&type=template&id=6a31d561&"
import script from "./bv-product-list.vue?vue&type=script&lang=ts&"
export * from "./bv-product-list.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports